import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const RecipientsPage = lazy(() => import('@/pages/recipients/ui/index'))

export const Route = createFileRoute('/_protected/recipients/list/')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <RecipientsPage />
    </Suspense>
  ),
})
